import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=1fdb2e22&scoped=true&"
import script from "./BoardCard.vue?vue&type=script&lang=js&"
export * from "./BoardCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=1fdb2e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb2e22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VSimpleTable})
